// export default SideBar;
import React, { useState, useEffect } from "react";
import Logo from "../../assets/FastRealtyLogo.png";
import DashBoardIcon from "../../assets/dashboardIcon.png";
import ProspectorIcon from "../../assets/prospectorIcon.png";
import RpfIcon from "../../assets/rpfIcon.png";
import DownArrowIcon from "../../assets/downArrowIcon.png";
import SettingsIcon from "../../assets/settings.png";
import myProfileIcon from "../../assets/myProfile.png";
import LogOutIcon from "../../assets/exit.png";
import { Auth } from "aws-amplify";
import RightArrow from "../../assets/rightArrow.png";
import { useHistory, useLocation } from "react-router-dom";

const SideBar = ({ onClose }) => {
  const history = useHistory();
  const location = useLocation();
  const [isProspectorOpen, setProspectorOpen] = useState(false);
  const [isRpfOpen, setRpfOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const signOut = async () => {
    try {
      await Auth.signOut();
      console.log("logout successful");
      localStorage.removeItem("token");
      history.push("./");
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };

  const handleDashbard = () => {
    history.push("/dashboard");
  };

  useEffect(() => {
    // Automatically open section based on current route
    if (location.pathname === "/prospector") {
      setProspectorOpen(true);
    } else if (location.pathname === "/requestreport") {
      setRpfOpen(true);
    }
  }, [location.pathname]);

  const activeStyle = {
    color: "#28a382",
    borderLeft: "3px solid #28a382",
    backgroundColor: "#f9f9f9",
  };

  return (
    <div className="sideBar-container">
      <div className="sideBar-top">
        <div className="sideBar-logo">
          <img src={Logo} alt="logo" className="sb-logo" />
          <img
            src={RightArrow}
            alt="right-arrow"
            className="right-arrow"
            onClick={onClose} // 🔥 This closes the sidebar
            style={{ cursor: "pointer" }}
          />
        </div>

        <div className="sideBar-content-container">
          {/* Dashboard */}
          <div
            className="dashboard-s"
            style={location.pathname === "/dashboard" ? activeStyle : {}}
            onClick={handleDashbard}
          >
            <div className="ds">
              <img
                src={DashBoardIcon}
                alt="dashboard-icon"
                className="dashboard-icon"
              />
              <p>Dashboard</p>
            </div>
          </div>

          {/* Prospector Section */}
          <div className="prospector">
            <div
              className="prospector-heading"
              style={
                location.pathname.startsWith("/prospector") ||
                location.pathname === "/call-list"
                  ? activeStyle
                  : {}
              }
              onClick={() => setProspectorOpen(!isProspectorOpen)}
            >
              <div className="prospector-s-ls">
                <img
                  src={ProspectorIcon}
                  alt="prospector-icon"
                  className="prospector-icon"
                />
                <p>Prospector</p>
              </div>
              <div className="prospector-s-rs">
                <img
                  src={DownArrowIcon}
                  alt="down-arrow-icon"
                  className="down-arrow-icon"
                  style={{
                    transform: isProspectorOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
            </div>

            {(isProspectorOpen ||
              location.pathname.startsWith("/prospector") ||
              location.pathname === "/call-list") && (
              <div className="prospector-hidden">
                <p
                  className="hidden-li"
                  style={isActive("/call-list") ? { color: "#28a382" } : {}}
                  onClick={() => {
                    setProspectorOpen(true);
                    history.push("/call-list");
                  }}
                >
                  Qualified Client List
                </p>
                <p
                  className="hidden-li"
                  style={
                    isActive("/fastrealty/magic_emails")
                      ? { color: "#28a382" }
                      : {}
                  }
                  onClick={() => {
                    setProspectorOpen(true);
                    history.push("/fastrealty/magic_emails");
                  }}
                >
                  Email Campaigns
                </p>
              </div>
            )}
          </div>

          {/* RPF Section */}
          <div className="prospector">
            <div
              className="prospector-heading"
              style={location.pathname === "/requestreport" ? activeStyle : {}}
              onClick={() => setRpfOpen(!isRpfOpen)}
            >
              <div className="prospector-s-ls">
                <img src={RpfIcon} alt="rpf-icon" className="prospector-icon" />
                <p>Request Proof of Funds</p>
              </div>
              <div className="prospector-s-rs">
                <img
                  src={DownArrowIcon}
                  alt="down-arrow-icon"
                  className="down-arrow-icon"
                  style={{
                    transform: isRpfOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
            </div>
            {(isRpfOpen || location.pathname === "/requestreport") && (
              <div className="prospector-hidden">
                <p
                  className="hidden-li"
                  style={
                    location.pathname === "/requestreport"
                      ? { color: "#28a382" }
                      : {}
                  }
                >
                  Request History
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="sideBar-bottom">
        <div className="sideBar-sp">
          {/* <div className="profile" onClick={() => history.push("/myaccount")}>
            <img src={myProfileIcon} alt="profile" className="profile-icon" />
            <p>My Profile</p>
          </div> */}
          <div
            className="profile"
            style={location.pathname === "/myaccount" ? activeStyle : {}}
            onClick={() => history.push("/myaccount")}
          >
            <img src={myProfileIcon} alt="profile" className="profile-icon" />
            <p>My Profile</p>
          </div>
        </div>
        <div className="lg" onClick={signOut}>
          <img src={LogOutIcon} alt="logOutIcon" className="logOut-icon" />
          <p>LogOut</p>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
